module.exports = __webpack_public_path__ + "img/aiHelloSend.bd6aa5c4.png";